export default __webpack_public_path__ + "static/media/insights-splash-tablet.b3089a29.png";